import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import type { Domain } from '../lib/domainRegistry'
import { DomainSelector, AddProjectForm } from '../components/add-project'

type Step = 'domain-selection' | 'form'

export function AddProjectPage() {
  const navigate = useNavigate()
  const [step, setStep] = useState<Step>('domain-selection')
  const [selectedDomain, setSelectedDomain] = useState<Domain | null>(null)

  const handleDomainSelect = (domain: Domain) => {
    setSelectedDomain(domain)
    setStep('form')
  }

  const handleBack = () => {
    setStep('domain-selection')
    setSelectedDomain(null)
  }

  const handleSuccess = (projectId: number) => {
    // Navigate to projects page with project detail open
    navigate(`/projects?project=${projectId}`)
  }

  return (
    <div className="min-h-screen bg-bg-body flex flex-col overflow-hidden">
      {/* Main content */}
      <main className="flex-1 overflow-y-auto">
        <div className="max-w-3xl mx-auto px-6 py-8">
          {step === 'domain-selection' && (
            <DomainSelector onSelect={handleDomainSelect} />
          )}

          {step === 'form' && selectedDomain && (
            <AddProjectForm
              domain={selectedDomain}
              onBack={handleBack}
              onSuccess={handleSuccess}
            />
          )}
        </div>
      </main>
    </div>
  )
}
